import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'

class ComplainHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            closeDate: "show"
        }
    }

    componentDidMount(){
        if(this.props.complain.status !== "Cerrado")
            this.setState({closeDate: "hidden"})
    }

    render() {
        let tittle = this.props.complain.customer === "Sí" ? 
                (`Folio ${this.props.complain.folio} - ${this.props.complain.name} - ${this.props.complain.project} ${this.props.complain.location}`) :
                (`Folio ${this.props.complain.folio} - ${this.props.complain.name}`) 
        return (
            <div className="container headerMessage">
                <header className="Form-header">
                    <h5 className="Form-title">{tittle}</h5>
                </header>
                <div className="row">
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Fecha de registro:&nbsp;</label>
                        <label>{new Date(this.props.complain.date).toDateString().slice(3, 15)}</label>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Email:&nbsp;</label>
                        <label>{this.props.complain.email}</label>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Teléfono:&nbsp;</label>
                        <label>{this.props.complain.phoneNumber}</label>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Responsable:&nbsp;</label>
                        <label>{this.props.complain.userId.name}</label>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Motivo:&nbsp;</label>
                        <label>{this.props.complain.reasonId.name}</label>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Área:&nbsp;</label>
                        <label>{this.props.complain.stageId.areaId.name}</label> 
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Etapa:&nbsp;</label>
                        <label>{this.props.complain.stageId.name}</label> 
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Estatus:&nbsp;</label>
                        <label className="status">{this.props.complain.status}</label> 
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <label className="tittle">Fecha de cierre:&nbsp;</label>
                        <label className={this.state.closeDate}>{new Date(this.props.complain.closeDate).toDateString().slice(3, 15)}</label> 
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <label className="tittle">Descripción:&nbsp;</label>
                        <label>{this.props.complain.description}</label>
                    </div>
                </div>
            </div>               
        )
    }
}

export default ComplainHeader


// WEBPACK FOOTER //
// ./src/components/ComplainHeader/ComplainHeader.js